module.exports = __webpack_public_path__ + "static/media/Golden_with_Type.c9926856.png";